export const spacing = {
  none: '0',
  tiny: '2px',
  xxs: '4px',
  xs: '8px',
  sm: '16px',
  md: '24px',
  lg: '32px',
  xl: '40px',
  xxl: '48px',
  '2xxl': '56px',
  '3xxl': '64px',
  '4xxl': '72px',
  '5xxl': '80px',
  '6xxl': '88px',
  '7xxl': '96px',
  '8xxl': '102px',
  '9xxl': '120px',
  auto: 'auto',
};

export const spacingNames = [
  'marginTop',
  'margin',
  'marginBottom',
  'marginLeft',
  'marginRight',
  'marginVertical',
  'marginHorizontal',
  'padding',
  'paddingTop',
  'paddingBottom',
  'paddingRight',
  'paddingLeft',
  'paddingVertical',
  'paddingHorizontal',
];
